import { defineMessages } from 'react-intl';

export const dashboardMessages = defineMessages({
    parkingZones: {
        id: 'parking-zones',
        defaultMessage: 'Parking zones',
    },
    metrics: {
        id: 'metrics',
        defaultMessage: 'Metrics',
    },
    cameras: {
        id: 'cameras',
        defaultMessage: 'Cameras',
    },
    eventLog: {
        id: 'event-log',
        defaultMessage: 'Event log',
    },
    fullLog: {
        id: 'view-full-log',
        defaultMessage: 'View full log of events',
    },
    totalSpaces: {
        id: 'total-spaces',
        defaultMessage: 'Total spaces',
    },
    parkingInvitation: {
        id: 'parking-invitation',
        defaultMessage: 'Parking invitation',
    },
    parkingInvitationSubtitle: {
        id: 'parking-invitation-subtitle',
        defaultMessage: 'You have been invited to join a new parking',
    },
    parkingInvitationDetails: {
        id: 'parking-invitation-details',
        defaultMessage: 'You have been invited to join {parking} parking by {from}. Would you like to join?',
    },
    parkingInvitationAcceptSuccess: {
        id: 'parking-invitation-accept-success',
        defaultMessage: 'Invitation accepted',
    },
    parkingInvitationAcceptDetails: {
        id: 'parking-invitation-accept-details',
        defaultMessage: 'You have successfully accepted the invitation to join {parking} parking',
    },
    notNow: {
        id: 'not-now',
        defaultMessage: 'Not now',
    },
    joinParking: {
        id: 'join-parking',
        defaultMessage: 'Join parking',
    },
    entries: {
        id: 'entries',
        defaultMessage: 'Entries',
    },
    exits: {
        id: 'exits',
        defaultMessage: 'Exits',
    },
    freeSpaces: {
        id: 'free-spaces',
        defaultMessage: 'Free spaces',
    },
    occupiedSpaces: {
        id: 'occupied-spaces',
        defaultMessage: 'Occupied spaces',
    },
    twentyFourHours: {
        id: 'twenty-four-hours',
        defaultMessage: 'Today',
    },
    sevenDays: {
        id: 'seven-days',
        defaultMessage: '7d',
    },
    availableSpacesLabel: {
        id: 'availableSpacesLabel',
        defaultMessage: 'available',
    },
    occupiedSpacesLabel: {
        id: 'occupiedSpacesLabel',
        defaultMessage: 'occupied',
    },
    ofAll: {
        id: 'of-all',
        defaultMessage: 'of all',
    },
    totalVisits: {
        id: 'total-visits',
        defaultMessage: 'Total visits',
    },
    fromYesterday: {
        id: 'from-yesterday',
        defaultMessage: 'from yesterday',
    },
    mostActive: {
        id: 'most-active',
        defaultMessage: 'Most active',
    },
    test: {
        id: 'test',
        defaultMessage: 'Test',
    },
    noCameras: {
        id: 'no-cameras',
        defaultMessage: 'No cameras',
    },
    noCamerasSubtitle: {
        id: 'no-cameras-subtitle',
        defaultMessage: 'There are no cameras connected to this parking',
    },
});
